module.exports = __webpack_public_path__ + "assets/48d8b2ac216d70740a39c834865609ad.mp3";